import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonationCardVM } from 'features/src/lib/donations/types/donations-feed/models';
import { DonationType } from 'features/src/lib/donations/types/donation-flow.models';
import { TimeAgoPipe } from '../../../pipes/time-ago.pipe';
import { CxTipDirective } from '../../../directives/tooltip.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'don-donation-card',
    imports: [CommonModule, TimeAgoPipe, CxTipDirective, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: `./donation-card.component.html`,
    styleUrls: ['./donation-card.component.css']
})
export class DonationCardComponent {
  @Input({ required: true }) vm!: DonationCardVM;
  @Output() like = new EventEmitter<string>();
  @Output() share = new EventEmitter<string>();

  get donationTypeLabel(): string {
    return this.vm?.donationType === DonationType.Recurring ? 'monthly' : 'one-time';
  }

  get amountWithType(): string {
    return this.vm?.donationType === DonationType.Recurring
      ? `${this.vm.amountLabel} / month`
      : `${this.vm.amountLabel} one-time`;
  }

  get initials(): string {
    const name = (this.vm?.title ?? '').trim();
    if (!name) return 'AN';
    const chunks = name.split(/\s+/).filter(Boolean);
    if (chunks.length === 1) {
      return chunks[0].slice(0, 2).toUpperCase();
    }
    return `${chunks[0][0] ?? ''}${chunks[1][0] ?? ''}`.toUpperCase();
  }
}
